import React from 'react';
import { connect } from 'react-redux'
import { IconContext } from "react-icons";
import { FaWindowClose, FaSave } from 'react-icons/fa';
const apiURL = process.env.REACT_APP_BACKEND

class ImageModal extends React.Component{
    constructor(props) {
        super(props);

        this.fetchImage = this.fetchImage.bind(this)
    }

    fetchImage() {
        fetch( apiURL + 'api/download', {
            method: 'get',
            headers: {
              'Accept': 'application/json',
              'Authorization': this.props.webToken
            },
            credentials: 'include'
        })
        .then(res => console.log(res.body))
        .then( data => console.log(data))
        .catch(err => console.log('Error: ', err))
    }

    render() {

        return (
            <div className="imageModalOverlay">
                <div className="imageModalContainer">
                    <div className="previewImageTimestamp">{ this.props.currentImageLabel } | { this.props.timestamp }</div>
                    <img className="previewImage" src={ apiURL + this.props.imageURI } alt={ '' } />

                    <div style={styles.icons}>
                        <a href={ apiURL + this.props.imageURI } download={ this.props.imageURI } target="blank">
                            <IconContext.Provider value={{ className: "imageSave" }}>
                                <FaSave style={{ height: '2.5vmin', width: '2.5vmin' }} />
                            </IconContext.Provider>
                        </a>

                        <IconContext.Provider value={{ className: "closeImagePreview" }}>
                            <FaWindowClose style={{ height: '2.5vmin', width: '2.5vmin' }} onClick={ this.props.closeImageModal } />
                        </IconContext.Provider>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        webToken: state.auth.webToken,
    }
}
export default connect(mapStateToProps)(ImageModal)

const styles = {
    icons: {
        position: 'absolute',
        top: '2%',
        right: '3%',
        display: 'flex',
        gap: '1vmin',
    }
}
